"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iframe = exports.title = exports.datasourceIcon = exports.a = exports.closeIcon = exports.titleWithIconGroup = exports.topSection = exports.exploringLayoutWrapper = void 0;
var index_1 = require("./index");
var fillAllParentSpaceStyle = {
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
};
var flexFixedSizeStyle = {
    flexGrow: 0,
    flexShrink: 0,
};
// Constant Variables
var topSectionHeight = '60px';
exports.exploringLayoutWrapper = (0, index_1.cssClass)('exploringLayoutWrapper', __assign(__assign({}, fillAllParentSpaceStyle), { position: 'absolute', display: 'flex', flexDirection: 'column', height: '100%', backgroundColor: 'rgb(250,250,250)' }));
exports.topSection = (0, index_1.cssClass)('topSection', __assign(__assign({}, flexFixedSizeStyle), { backgroundColor: 'rgb(68, 126, 160)', height: topSectionHeight, display: 'flex', justifyContent: 'space-between' }));
exports.titleWithIconGroup = (0, index_1.cssClass)('titleWithIconGroup', {
    display: 'flex',
    margin: '10px 0px 10px 9px',
    padding: '10px 10px 10px 6px',
    alignItems: 'center',
    textDecoration: 'none',
    backgroundColor: 'rgb(68, 126, 160)',
    justifyContent: 'space-between',
    '$nest': {
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
        },
    },
});
exports.closeIcon = (0, index_1.cssClass)('closeIcon', {
    marginRight: '10px',
    marginTop: '10px',
    height: '14px',
    opacity: 0.8,
    '$nest': {
        '&:hover': {
            opacity: 1,
        },
        '&:active': {
            opacity: 1,
        },
    },
});
exports.a = (0, index_1.cssClass)('a', {
    display: 'flex',
    textDecoration: 'none',
});
exports.datasourceIcon = (0, index_1.cssClass)('datasourceIcon', {
    marginBottom: '1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});
exports.title = (0, index_1.cssClass)('title', {
    fontSize: '14px',
    color: 'white',
    marginLeft: '6px',
    display: 'flex',
    alignItems: 'center',
});
exports.iframe = (0, index_1.cssClass)('iframe', {
    border: 'none',
    width: '100%',
    height: '100%',
});
//# sourceMappingURL=SectionStyles.js.map